import Vue from 'vue'
import FormText from './form-text.vue' // 1
import FormCode from './form-code.vue'
import FormLink from './form-link.vue' // 1
import FormNumber from './form-number.vue' // 1
import FormDate from './form-date.vue' // 1
import FormDateCheckbox from './form-date-checkbox.vue' // 1
import FormUnit from './form-unit.vue' // 1
import FormImage from './form-image.vue' // 1
// import FormSelect from './form-select.vue'
import CertFormSelect from './cert-form-select.vue' // 1
import InspectFormSelect from './inspect-form-select.vue' // 1
import PlatFormSelect from './plat-form-select.vue' // 1
import BreedFormSelect from './breed-form-select.vue' // 1
import WorkFormSelect from './work-form-select.vue' // 1

Vue.component('smart-form', {
  functional: true,
  props: {
    item: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    cb: Function,
    prop: String,
    productId: [String, Number],
    vendorId: [Number, String],
    tradeType: [String, Number],
    status: {
      type: String,
      default: 'edit'
    }
  },
  render (createElement, context) {
    function appropriateListComponent () {
      let items = context.props.item
      if (items.type === 'LINK') return FormLink
      if (items.type === 'TEXT') {
        if (items.name === 'hsCode') {
          return FormCode
        } else {
          return FormText
        }
      }
      if (items.type === 'NUMBER') return FormNumber
      if (items.type === 'DATE') return FormDate
      if (items.type === 'PRODUCTION_DATE') return FormDateCheckbox
      if (items.type === 'IMAGE') return FormImage
      if (items.type === 'NUMBER2TIMEUNIT') return FormUnit
      if (items.type === 'NUMBER2NETCONTENT') return FormUnit
      if (items.type === 'TRACING_PLAT_INFO') return PlatFormSelect
      if (items.type === 'TRACING_BREED_INFO') return BreedFormSelect
      if (items.type === 'TRACING_WORK_INFO') return WorkFormSelect
      if (items.type === 'CERTIFICATE') return CertFormSelect
      if (items.type === 'INSPECT_REPORT') return InspectFormSelect
    }
    console.log(context.props)
    return createElement(
      appropriateListComponent(),
      {
        props: {
          ...context.props
        }
      },
      []
    )
  }
})
